// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__32FwK","primary":"Button_primary__CVuDV","secondary":"Button_secondary__19x43","fullwidth":"Button_fullwidth__3A_M4"};